var initInterval = setInterval(function(){
    if(window.jQuery) {
            clearInterval(initInterval);
            initCustom();
        }
    }, 20);
function avocaWaitForElm(selector) {
      return new Promise(resolve => {
          if (document.querySelector(selector)) {
              return resolve(document.querySelector(selector));
          }
  
          const observer = new MutationObserver(mutations => {
              if (document.querySelector(selector)) {
                  resolve(document.querySelector(selector));
                  observer.disconnect();
              }
          });
  
          observer.observe(document.body, {
              childList: true,
              subtree: true
          });
      });
  }
function initCustom(){
  jQuery(document).ready(function($){

  //  document.addEventListener("BuuntoDatePicker:selectionChange", (e) => {
  //   const { method, date, dateDisplay, timeSlot, timeSlotDisplay } = e.detail
  //    console.log(date);
  //     $.post('/cart.js', {
  //       attributes: {
  //         'Delivery Date (YYYY-MM-DD)': date
  //       }
  //     }).done(function () {});
  // })

    $('#choose-a-location-type').on('change keyup keydown', function () {
      $.post('/cart.js', {
      attributes: {
        'Location type': $(this).val()
      }
      }).done(function () {});
    });
     $(".thb-cart-form--cart-collaterals").LoadingOverlay("show");
    alertify.defaults.glossary.title = "The Flower Run - Flowers Perth";
    if($('.tcustomizer-customization-form .tcustomizer-field.addon-gift').length){
      if($('.tcustomizer-customization-form .tcustomizer-field.addon-gift .tcustomizer-field__input .tcustomizer-row .tcustomizer-col').length > 3){
        $('.tcustomizer-customization-form .tcustomizer-field.addon-gift .tcustomizer-field__input .tcustomizer-row').slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: true,
          fade: false,
          infinite: false,
          autoplay: true,
          autoplaySpeed: 2000
        });
      }
    }
    if($('.addon-product-column').length){
      $('.addon-product-column').slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: true,
          fade: false,
          infinite: false,
          autoplay: true,
          autoplaySpeed: 2000
        });
    }
    $(document).on('click','.product-add-to-cart-container.current-addon-product .single-add-to-cart-button',function(e){
      e.preventDefault();
      const cartContents = fetch(window.Shopify.routes.root + 'cart.js')
        .then((response) => response.json())
        .then((data) => {
          return data.items;
        });
      
      const cartContentsItems = async () => {
        const a = await cartContents;
        if(a.length){
          $(".form-container form").trigger("submit");
        } else {
          if($('.form-container').get(0).classList.contains('package')){
            alertify.alert("Please choose a <a style='text-decoration:underline;font-weight:600;' href='/collections/wedding-packages' target='_blank'>Wedding Package</a> before adding any Add-on Products");
          } else {
            alertify.alert("Please choose a <a style='text-decoration:underline;font-weight:600;' href='/collections/flowers' target='_blank'>Flower Bunch</a> or <a style='text-decoration:underline;font-weight:600;' href='/collections/plants' target='_blank'>Plant</a> before adding any Add-on Products");
          }
        }
      };
      
      cartContentsItems();
    });
    avocaWaitForElm('.neo-slot-picker').then((elm) => {
        $('.neo-slot-picker').append('<svg xmlns="http://www.w3.org/2000/svg" height="16" width="14" viewBox="0 0 448 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2023 Fonticons, Inc.--><path d="M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm64 80v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm128 0v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H336zM64 400v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H208zm112 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H336c-8.8 0-16 7.2-16 16z"/></svg>');
        $(".thb-cart-form--cart-collaterals").LoadingOverlay("hide");
    });
    avocaWaitForElm('#order-slots #additional-message').then((elm) => {
        if($('#order-slots #additional-message').html() == ''){
          $('#order-slots #additional-message').hide();
        }
    });
    avocaWaitForElm('.addon-gift').then((elm) => {
        let listAddOn = jQuery('.tcustomizer-field.addon-gift .tcustomizer-field__input .tcustomizer-col label .tcustomizer-tooltip .tcustomizer-tooltip--content');
        for(let lo = 0;lo < listAddOn.length;lo++){
            let priceString = _TC.addonVariants[lo].price;
            let priceConvert = priceString / 100;
            let onDollar = new Intl.NumberFormat("en-US", {style: "currency", currency: "USD"}).format(priceConvert);
            let productHandle = _TC.addonVariants[lo].product_handle;
            let productTitle = _TC.addonVariants[lo].title;
            let linkProductAddOn = '/collections/add-ons/products/'+productHandle;
            jQuery(listAddOn[lo]).append('<span class="tooltip-text-price">'+onDollar+'</span><a class="vp-add-on" href="'+linkProductAddOn+'" title="'+productTitle+'" target="_blank">View Product</a>');
        }
    });
    avocaWaitForElm('a[title="REGISTER INTEREST"]').then((elm) => {
        if($('a[title="REGISTER INTEREST"]').length){
          $('a[title="REGISTER INTEREST"]').attr('target', '_blank');
        }
    });
    document.body.addEventListener("submit", function (e) {
      if (e.target.getAttribute("action") === "/cart") {
          /*if(document.querySelector('#choose-a-location-type').value === "" && document.querySelector('#deliverydate').value === "") {
            e.preventDefault();
            e.stopPropagation();
            alert("Please select a location type and delivery date");
            return false;
          }
          if(document.querySelector('#choose-a-location-type').value !== "" && document.querySelector('#deliverydate').value === "") {
            e.preventDefault();
            e.stopPropagation();
            alert("Please select a delivery date");
            return false;
          }
          if(document.querySelector('#choose-a-location-type').value === "" && document.querySelector('#deliverydate').value !== "") {
            e.preventDefault();
            e.stopPropagation();
            alert("Please select a location type");
            return false;
          }*/
        if (document.querySelector('#choose-a-location-type').value === "") {
          e.preventDefault();
          e.stopPropagation();
          alert("Please select a location type");
          return false;
        }
      }
    });
    avocaWaitForElm('#tcustomizer-form-field-491264-8735462261018').then((elm) => {
        $('#tcustomizer-form-field-491264-8735462261018').on('mouseleave change input', function(){
            // var remove_emoji = $(this).val().replace(/[^\p{L}\p{N}\p{P}\p{Z}{\^\$}]/gu,'').replace(/[\n\r\s\t]+/g, ' ');
            var remove_emoji = $(this).val().replace(/[^\p{L}\p{N}\p{P}\p{Z}\n]/gu,'');
            $(this).val(remove_emoji);
        });
    });
  });
}